var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSentra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2847_82019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2891 0H9.28906V6H24.2891V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.0977H0V24.0977H15V18.0977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0H0V6H6V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18H18V24H24V18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9271 15.3447C13.7443 15.3447 15.2174 13.8475 15.2174 12.0005C15.2174 10.1536 13.7443 8.65625 11.9271 8.65625C10.1099 8.65625 8.63672 10.1536 8.63672 12.0005C8.63672 13.8475 10.1098 15.3447 11.9271 15.3447Z",
    fill: "#F4A72B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9H0V15H6V9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 9H18V15H24V9Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2847_82019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentra);
export default __webpack_public_path__ + "static/media/Sentra.429abe786eedd05baa105c951bfc285c.svg";
export { ForwardRef as ReactComponent };